export default {
  defaultProps: {
    disableAutoFocus: true,
    disableEnforceFocus: true,
  },
};
